import { filterOptions } from '@witmetrics/unison-core';
import { useLabProducts } from '@witmetrics/data-store';
import { findById } from '@witmetrics/utils/arrays';
import type { DraftOrderProduct } from '@/types/orders';
import SearchableDropdown from '@/components/inputs/SearchableDropdown';
import { classes, sortProducts } from './utils';

export type NewProductFieldProps = {
  labId: number;
  onSelect: (update: DraftOrderProduct) => void;
};

export default function NewProductField({
  labId,
  onSelect,
}: NewProductFieldProps) {
  const labProducts = useLabProducts(labId);

  const handleSelect = (productId?: number) => {
    if (!productId) return;
    const product = findById(labProducts, productId)!;
    onSelect({ productId, price: product.price, quantity: 1 });
  };

  return (
    <div className={classes.wrapper}>
      <SearchableDropdown<number>
        clearOnSelect
        blurOnSelect
        className={classes.productDropdown}
        label="Add product"
        value={null}
        initialOptions={sortProducts(labProducts)}
        onSearch={async (search) =>
          filterOptions(search, sortProducts(labProducts))
        }
        onSelect={(update) => handleSelect(update?.value)}
      />
    </div>
  );
}
